import type { ComponentProps } from 'react';
import EmbedSafeAnchor from '@onramp/components/embedding/EmbedSafeAnchor';
import { Link } from '@cbhq/cds-web/typography';

type Variant = ComponentProps<typeof Link>['variant'];

export const NETWORK_FEE_LINK =
  'https://help.coinbase.com/en/coinbase/trading-and-funding/pricing-and-fees/fees';

export function learnMoreAboutFeesLink(text: string, variant?: Variant, underline?: boolean) {
  return (
    <EmbedSafeAnchor href={NETWORK_FEE_LINK} target="_blank">
      <Link underline={!!underline} variant={variant} href={`"#"`}>
        {text}
      </Link>
    </EmbedSafeAnchor>
  );
}

export const ASSETS_MULTIPLE_NETWORK_LINK =
  'https://help.coinbase.com/en/coinbase/trading-and-funding/sending-or-receiving-cryptocurrency/assets-on-multiple-networks';

export function learnMoreAboutAssetsOnMultipleNetworksLink(
  text: string,
  variant?: Variant,
  underline = false,
) {
  return (
    <EmbedSafeAnchor href={ASSETS_MULTIPLE_NETWORK_LINK} target="_blank">
      <Link underline={underline} variant={variant} href={`"#"`}>
        {text}
      </Link>
    </EmbedSafeAnchor>
  );
}

export const UNDERSTANDING_SLIPPAGE_AND_SPREAD_LINK =
  'https://help.coinbase.com/en/coinbase/trading-and-funding/buying-selling-or-converting-crypto/understanding-slippage-and-spread';

export function learnMoreAboutSlippageAndSpreadLink(
  text: string,
  variant?: Variant,
  underline?: boolean,
) {
  return (
    <EmbedSafeAnchor href={UNDERSTANDING_SLIPPAGE_AND_SPREAD_LINK} target="_blank">
      <Link underline={underline} variant={variant} href={`"#"`}>
        {text}
      </Link>
    </EmbedSafeAnchor>
  );
}

export const FCA_INFO_LINK = 'https://www.coinbase.com/en-gb/uk-fca-info';
export function learnMoreAboutFcaLink(text: string, variant?: Variant, underline?: boolean) {
  return (
    <EmbedSafeAnchor href={FCA_INFO_LINK} target="_blank">
      <Link underline={underline} variant={variant} href={`"#"`}>
        {text}
      </Link>
    </EmbedSafeAnchor>
  );
}

export function createSupportEmailLink(href: string) {
  return function supportEmailLink(text: string) {
    return (
      <Link href={href} variant="body">
        {text}
      </Link>
    );
  };
}

export const TRANSFER_SETTINGS_LINK = 'https://accounts.coinbase.com/security/transfer-protection';
export function transferSettingsLink(text: string, variant?: Variant, underline?: boolean) {
  return (
    <EmbedSafeAnchor href={TRANSFER_SETTINGS_LINK} target="_blank">
      <Link underline={underline} variant={variant} href={`"#"`}>
        {text}
      </Link>
    </EmbedSafeAnchor>
  );
}
